import * as React from "react";
import { forwardRef } from "react";
const SvgPause = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 19H10V5H6V19ZM14 5V19H18V5H14Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgPause);
export default ForwardRef;
